<!-- 采购退货 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button v-if="permission.add" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoDetails(3)">{{ permission.add }} (F3)</el-button>
                <el-button v-if="permission.add_v2" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoDetails(5)">{{ permission.add_v2 }} (F4)</el-button>
                <el-button v-if="permission.total" size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">{{ permission.total }}</el-button>
                <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                    permission.print
                }}</el-button>
                <el-button v-if="permission.printPreview && !isDefaultSet" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview()">{{
                    permission.printPreview
                }}</el-button>
                <el-button
                    v-if="(permission.printPreview || permission.print) && isDefaultSet"
                    size="small"
                    icon="el-icon-printer"
                    class="search-btn btn-primary"
                    @click="printPreview()"
                    >打印</el-button
                >
                <el-button v-if="permission.export" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm()">{{ permission.export }}</el-button>
                <el-button v-if="permission.retrunHistory" size="small" class="search-btn btn-primary" @click="history()">{{ permission.retrunHistory }}</el-button>
            </div>
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn purreturn-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                border=""
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; cursor: pointer"
                highlight-current-row
                @cell-dblclick="handleDBClick"
                :row-key="getRowKeys"
                v-loading="loading"
                :tableCode="tableCode"
                @sort-change="sortChange"
                :summary-method="getSummaries"
                show-summary
            >
                <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                <template v-for="(col,index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '175px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'ReturnCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                {{ scope.row.ReturnCode }}
                            </el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.ReturnCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OrderCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div style="color: #409eff" @click="gotoPurDetails(scope.row)" type="text" size="small">{{ scope.row.OrderCode }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OrderCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.OrderType == 0" style="color: #409eff" @click="gotoSalesDetails(scope.row)" type="text">
                                {{ scope.row.OrderCode }}
                            </div>
                            <span v-else-if="scope.row.OrderType == 1"> 明细售后 </span>
                            <span v-else style="color: #e6a23c"> 无单售后 </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'WarehouseName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.WarehouseName }}
                            <span v-if="scope.row.WarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'RefundStateName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.RefundStateName == '已退款'" class="c-active">{{ scope.row.RefundStateName }}</i>
                            <i v-else>{{ scope.row.RefundStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OutWarehouseStateName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.OutWarehouseStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column label="操作" fixed="right" :isCanSet="true" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit && scope.row.IsCanUpdate" @click="gotoDetails(2, scope.row)" type="text" size="small">{{ permission.edit }}</el-button>
                            <el-button v-if="permission.edit_v2 && scope.row.IsCanUpdate" @click="gotoDetails(7, scope.row)" type="text" size="small">{{ permission.edit_v2 }}</el-button>

                            <el-button v-if="permission.submit && scope.row.IsCanSubmit" @click="submit(scope.row)" type="text" size="small">{{ permission.submit }}</el-button>
                            <el-button
                                v-if="permission.UpdateOrderAfterSubmit && scope.row.IsCanUpdateAfterSubmit"
                                title="修改订单"
                                size="mini"
                                type="text"
                                @click="gotoDetails(4, scope.row)"
                                >{{ permission.UpdateOrderAfterSubmit }}</el-button
                            >
                            <el-button
                                v-if="permission.UpdateOrderAfterSubmit_v2 && scope.row.IsCanUpdateAfterSubmit"
                                title="修改订单_v2"
                                size="mini"
                                type="text"
                                @click="gotoDetails(6, scope.row)"
                                >{{ permission.UpdateOrderAfterSubmit_v2 }}</el-button
                            >
                            <el-button
                                v-if="permission.transIOrder && scope.row.IsCanTransToInquiry"
                                :title="permission.transIOrder"
                                size="mini"
                                type="text"
                                @click="gotoIOrder(scope.row)"
                                >{{ permission.transIOrder }}</el-button
                            >
                            <el-button v-if="permission.del && scope.row.IsCanDelete" @click="del(scope.row)" type="text" size="small" style="color: red">{{
                                permission.del
                            }}</el-button>
                            <el-button v-if="permission.cancel && scope.row.IsCanCancel" @click="cancel(scope.row)" type="text" size="small" style="color: orange">{{
                                permission.cancel
                            }}</el-button>
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{ permission.opRecords }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="buyReturn"></statistics>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="采购退货单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="OrderId" :OrderType="3" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="860px">
            <div class="dialog-content" v-if="dialogVisible">
                <printPRContent @closeDialog="closeDialog" :printIds="multipleSelection" :isInit="true"></printPRContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printPRContent ref="printDom" @closeDialog="closeDialog" :printIds="multipleSelection" :isInit="false"></printPRContent>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="售后单据搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-return-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="供应商">
                        <el-select
                            ref="search_sup"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.EntpCusName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入供应商名称"
                            :remote-method="searchSupplier"
                            v-select-scroll-more="searchSupplierLoad"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="退货单号">
                        <el-input size="small" v-model.trim="searchData.ReturnCode" v-filter-special-char="searchData.ReturnCode" placeholder="请输入退货单号"></el-input>
                    </el-form-item>
                    <el-form-item label="出库仓库"  v-if="isExObj('WarehouseName')">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购单号"  v-if="isExObj('OrderCode')">
                        <el-input size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="请输入采购单号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态"  v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.RState">
                            <el-option v-for="item in orderStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单部门" v-if="isExObj('OrgName')">
                        <el-select
                            size="small"
                            class="search-item"
                            style="width: 100%"
                            v-model="searchData.OrgId"
                            filterable
                            clearable
                            collapse-tags
                            reserve-keyword
                            @visible-change="orgVisibleChange($event)"
                            placeholder="请选择"
                        >
                            <el-option v-for="optionItem in orgSearchData" :key="optionItem.Id" :data-msg="optionItem" :label="optionItem.Name" :value="optionItem.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购员"  v-if="isExObj('SName')">
                        <el-select
                            v-model="searchData.SId"
                            style="width: 100%"
                            size="small"
                            filterable
                            clearable
                            remote
                            placeholder="请选择"
                            @visible-change="siVisibleChange($event)"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期"  v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期"  v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="退货日期"  v-if="isExObj('ReturnTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期"  v-if="isExObj('ConfirmTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes4"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate4TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="出库日期"  v-if="isExObj('WHFinishTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes5"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate5TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import statistics from '@/components/common/statistics.vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import ordersLifes from '@/components/common/ordersLifes';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        statistics,
        breadcrumb,
        elTableColumn,
        ordersLifes
    },
    data() {
        return {
            tableCode: 'PurReturnTable',
            isStopReq: false,
            loading: false,
            summaryStr: '',
            dateTimes1: [],
            dateTimes2: [],
            dateTimes3: [],
            dateTimes4: [],
            dateTimes5: [],
            orgSearchData:[],
            dialogSearchVisible: false,
            isDefaultSet: true,
            statisticsVisible: false,
            multipleSelection: null,
            OrderId: '',
            OrderLifesVisible: false,
            tableData: [],
            options: [],
            searchData: {
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                RStartDate: '',
                REndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                WarehouseId: '',
                SortProp: '',
                SortType: '',
                OrgId: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            permission: {},
            RefuseReasonForm: { rid: '', reason: '', index: 0 },
            rules: {
                reason: [
                    { required: true, message: '请输入原因', trigger: 'blur' },
                    { max: 100, message: '原因长度超长', trigger: 'blur' }
                ]
            },
            reasonFormData: {},
            orderStateList: [
                { Text: '全部', Value: '' },
                { Text: '不需退款', Value: '5' },
                { Text: '未退款', Value: '10' },
                { Text: '已退定金', Value: '15' },
                { Text: '完成退款', Value: '20' },
                { Text: '不需出仓', Value: '25' },
                { Text: '未出仓', Value: '30' },
                { Text: '部分出仓', Value: '35' },
                { Text: '已出仓', Value: '40' },
                { Text: '已完成', Value: '45' },
                { Text: '已撤销', Value: '50' }
            ],
            SIdList: [],
            warehouseList: [],
            dialogVisible: false,
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isStartSearch: false,
            isPreview: false, //是否出现预览界面
            isRegister: false,
            columnShowSets: [],
            isRemarkShow:false,
            isForceRemark:false,
            isRemarkSelect:false,
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_sup.focus();
                });
            }
        }
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            if (this.$store.state.orderData && this.$store.state.orderData.Id) {
                this.getSingleData(this.$store.state.orderData, true);
            }
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        this.multipleSelection = null;
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('purchasesReturns');
        that.getPrintComponents();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (that.statisticsVisible || that.dialogVisible) return;
            //F2
            if (key === 113) {
                e.preventDefault();
                if (that.SIdList.length <= 1) that.getSIdList();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.gotoDetails(3);
                return;
            }
            if (key === 115) {
                e.preventDefault();
                that.gotoDetails(5);
                return;
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
                else{
                    that.resetSearch();
                    that.getTableData();
                }
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['syllqdysz', 'djmrdtsj', 'dyyl','cgthspzsbz','cgspbzbt','cgthspxzbz'];
            let isDefaultToday = false;
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'syllqdysz':
                                that.isDefaultSet = result;
                                break;
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'dyyl': //是否出现预览界面
                                that.isPreview = result;
                                break;
                            case 'cgthspzsbz': //展示备注列
                                this.isRemarkShow = result;
                                break;
                            case 'cgspbzbt': //备注必填
                                this.isForceRemark = result;
                                break;
                            case 'cgthspxzbz': //采购备注是否开启下拉
                                this.isRemarkSelect = result;
                                break;   
                        }
                    }
                    if (isDefaultToday && that.isExObj('CreateTime')) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.dateTimes1.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.dateTimes1.unshift(date2);

                        that.searchData.StartDate = date2;
                        that.searchData.EndDate = date1;
                    }
                }
                that.getTableData();
            });
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(5).then(data => {
                if (data) {
                    Vue.component('printPRContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printPRContent', () => import('@/components/printModels/printPurReturn'));
                    that.isRegister = true;
                }
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.PReturnId;
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        getSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.SIdList = data;
            });
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog(isPrint) {
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.PReturnId == this.multipleSelection[0].PReturnId) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
                this.multipleSelection = null;
            }

            this.statisticsVisible = false;
            this.dialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        submit(row) {
            let that = this;
            if(that.isRemarkShow && that.isForceRemark){
                that.$util.elConfirm({
                content: '确定要提交该退货单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpPurReturnOrder/CheckEntpPurReturnOrder?PReturnId=${row.PReturnId}`
                        })
                        .then(res => {
                            if(res.errcode == 0){
                                that.$util
                                    .axiosPost({
                                        url: `/api/EntpPurReturnOrder/SubmitEntpPurReturnOrder?PReturnId=${row.PReturnId}`
                                    })
                                    .then(() => {
                                        that.$util.successMsg('提交成功');
                                        that.getSingleData({ Id: row.PReturnId, IsAdd: false }, false);
                                    });
                            }else{
                                that.$util.warningMsg(res.errmsg);
                            }
                        })
                    }
                });
            }else{
                that.$util.elConfirm({
                content: '确定要提交该退货单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpPurReturnOrder/SubmitEntpPurReturnOrder?PReturnId=${row.PReturnId}`
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getTableData();
                        });
                    }
                });
            }
        },
        // 跳转到采购单详情
        gotoPurDetails(row) {
            //   this.$router.push(
            //     `/purchaseManage/purchaseOrders/edit_v2?type=1&id=${row.EntpCusPOId}`
            //   );
            this.$router.push(`/purchaseManage/purchaseOrders/check?id=${row.EntpCusPOId}`);
        },
        // 删除询价
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该退货单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpPurReturnOrder/DelEntpPurReturnOrder?PReturnId=${row.PReturnId}`
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            let idx = that.tableData.findIndex(f => f.PReturnId === row.PReturnId);
                            that.tableData.splice(idx, 1);

                            that.tableDataLength -= 1;
                        })
                        .catch(() => {});
                }
            });
        },
        cancel(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要撤销该退货单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpPurReturnOrder/CancelEntpPurchaseReturnOrder?PReturnId=${row.PReturnId}`
                        })
                        .then(() => {
                            that.$util.successMsg('撤销成功');
                            that.getSingleData({ Id: row.PReturnId, IsAdd: false }, true);
                        })
                        .catch(() => {});
                }
            });
        },
        resetSearch() {
            this.searchData = {
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                RStartDate: '',
                REndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                WarehouseId: '',
                SortProp: '',
                SortType: '',
                OrgId: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.dateTimes1 = [];
            this.dateTimes2 = [];
            this.dateTimes3 = [];
            this.dateTimes4 = [];
            this.dateTimes5 = [];
            this.searchSupplier('');
            this.$refs.multipleTable.clearSelection();
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            let PReturnId = item ? item.PReturnId : '';
            let EntpCusPOId = item ? item.EntpCusPOId : '';
            if(type == 1 || type == 2 || type == 3 || type == 4){
                this.$router.push(`/purchaseManage/purchasesReturns/edit_v2?type=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
            }else if(type == 6){
                type = 4;
                this.$router.push(`/purchaseManage/purchasesReturns/edit_v3?type=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
            }else if(type == 7){
                type = 2;
                this.$router.push(`/purchaseManage/purchasesReturns/edit_v3?type=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
            }else{
                type = 3;
                this.$router.push(`/purchaseManage/purchasesReturns/edit_v3?type=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
            }
        },
        // 跳转历史配件采购
        history() {
            this.$router.push(`/purchaseManage/purchasesReturns/retrunPrhistories`);
        },
        //转询价
        gotoIOrder(item) {
            this.$router.push(`/purchaseManage/inquirySheet/edit_v2?type=6&rid=${item.PReturnId}`);
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurReturnOrder/GetSupPurchaseReturnOrderList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        if (data.DataList) this.tableData = data.DataList;
                        else this.tableData = [];
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                            this.summaryStr = data.SummaryStr;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.gotoDetails(1, event);
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        opRecords(item) {
            let id = item ? item.PReturnId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        // 打印
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            let listArr = this.multipleSelection;
            if (!listArr || listArr.length !== 1) {
                this.$util.warningMsg('请选择一张采购退货单打印');
                return;
            }
            if (!['已提交', '已完成'].includes(listArr[0].StateName)) {
                this.$util.warningMsg('只能打印已提交和已完成的采购退货单');
                return;
            }
            this.dialogVisible = true;
        },
        print() {
            let listArr = this.multipleSelection;
            if (!listArr || listArr.length !== 1) {
                this.$util.warningMsg('请选择一张采购退货单打印');
                return;
            }
            if (!['已提交', '已完成'].includes(listArr[0].StateName)) {
                this.$util.warningMsg('只能打印已提交和已完成的采购退货单');
                return;
            }
            let LODOP = this.$lodop.getLodop();
            if (!LODOP) return;
            let that = this;
            this.$refs.printDom.init(true);
        },
        // 导出
        exportForm() {
            let arr = this.multipleSelection;
            if (arr.length == 0) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let idArr = [];
            for (let i = 0; i < arr.length; i++) {
                if (!['已提交', '已完成'].includes(arr[i].StateName)) {
                    this.$util.warningMsg('只能导出已提交和已完成的采购退货单');
                    return;
                }
                idArr.push(arr[i].PReturnId);
            }
            let OIds = idArr.join(',');
            this.$util.exportFile({
                url: '/api/EntpPurReturnOrder/ExportPurReturnOrders',
                data: {
                    OIds: OIds
                }
            });
        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.RStartDate = val[0];
                this.searchData.REndDate = val[1];
            } else {
                this.searchData.RStartDate = '';
                this.searchData.REndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate5TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'PayTypeName' ||
                    column.property == 'OrderCode' ||
                    column.property == 'Creator' ||
                    column.property == 'SName' ||
                    column.property == 'Remark' ||
                    column.property == 'ConfirmTime' ||
                    column.property == 'WHFinishTime' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'CreateTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        getSingleData(param, isUpdate) {
            let that = this;
            that.$store.commit('updateOrderList', { Id: '', IsAdd: false });
            if (param.IsAdd && this.searchData.page == 1) {
                //获取单条数据，插入就行，删掉最后一条
                that.$util
                    .axiosGet({
                        url: '/api/EntpPurReturnOrder/GetSigleOrderData',
                        data: {
                            Id: param.Id,
                            IsUpdate: isUpdate
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (that.tableData.length == that.searchData.limit) that.tableData.splice(-1, 1);
                            that.tableData.unshift(res.data.DataList[0]);

                            that.tableDataLength += 1;
                            
                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            } else {
                //获取单条，更新
                that.$util
                    .axiosGet({
                        url: '/api/EntpPurReturnOrder/GetSigleOrderData',
                        data: {
                            Id: param.Id,
                            IsUpdate: isUpdate
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            let idx = that.tableData.findIndex(f => f.PReturnId === param.Id);
                            that.tableData.splice(idx, 1, res.data.DataList[0]);

                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-return-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.purreturn-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
